module.exports = __webpack_public_path__ + "static/media/plate2Img3.73df8ce0.png";